var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100"
  }, [_vm.error && _vm.error.key ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.error.key)) + " ")]) : _vm._e(), _c('b-form', {
    staticClass: "w-100",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "id": "event-flow-start-date",
      "mode": "date",
      "icon": "",
      "max-date": _vm.maxStartDate,
      "label": _vm.$t('event-flow.popup.form.start-date'),
      "required": ""
    },
    model: {
      value: _vm.formData.startedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "startedAt", $$v);
      },
      expression: "formData.startedAt"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "id": "event-flow-start-time",
      "mode": "time",
      "max-date": _vm.maxStartDate,
      "label": _vm.$t('event-flow.popup.form.start-time'),
      "required": ""
    },
    model: {
      value: _vm.formData.startedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "startedAt", $$v);
      },
      expression: "formData.startedAt"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "id": "event-flow-start-date",
      "mode": "date",
      "icon": "",
      "min-date": _vm.formData.startedAt,
      "max-date": _vm.effectiveMaxDateTime,
      "label": _vm.$t('event-flow.popup.form.end-date'),
      "required": ""
    },
    model: {
      value: _vm.formData.endedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "endedAt", $$v);
      },
      expression: "formData.endedAt"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('date-time-picker', {
    attrs: {
      "id": "event-flow-start-time",
      "mode": "time",
      "min-date": _vm.formData.startedAt,
      "max-date": _vm.effectiveMaxDateTime,
      "label": _vm.$t('event-flow.popup.form.end-time'),
      "required": ""
    },
    model: {
      value: _vm.formData.endedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "endedAt", $$v);
      },
      expression: "formData.endedAt"
    }
  })], 1)], 1), _vm.submitted && !_vm.$v.formData.endedAt.minValue ? _c('small', {
    staticClass: "text-danger danger-msg"
  }, [_vm._v(" " + _vm._s(_vm.$t('validation.end-date.after-start')) + " ")]) : _vm._e()], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "event-brief",
      "label": _vm.$t('event-flow.popup.form.brief'),
      "state": _vm.getState('brief'),
      "type": "text",
      "maxlength": 30
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [_c('div', {
          staticClass: "character-counter"
        }, [_vm._v(" " + _vm._s(_vm.formData.brief.length) + " / 30 ")]), !_vm.$v.formData.brief.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('event-flow.popup.form.brief'),
          max: _vm.$v.formData.brief.$params.maxLength.max
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formData.brief,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "brief", $$v);
      },
      expression: "formData.brief"
    }
  }), _c('b-form-group', {
    attrs: {
      "id": "event-description-group",
      "label": _vm.$t('event-flow.popup.form.description'),
      "label-for": "event-description-field"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "event-description-field",
      "rows": "3",
      "state": _vm.getState('description')
    },
    model: {
      value: _vm.formData.description,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "description", $$v);
      },
      expression: "formData.description"
    }
  }), !_vm.$v.formData.description.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
    field: _vm.$t('event-flow.popup.form.description'),
    max: _vm.$v.formData.description.$params.maxLength.max
  })) + " ")]) : _vm._e()], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('form-selector', {
    attrs: {
      "id": "event-location-select",
      "options": _vm.locationOptions,
      "label": _vm.$t('event-flow.popup.form.location'),
      "loading": _vm.locationsLoading,
      "empty-option-text": _vm.$t('event-flow.popup.form.location-choose'),
      "has-empty-option": ""
    },
    model: {
      value: _vm.formData.location,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "location", $$v);
      },
      expression: "formData.location"
    }
  }), _c('form-selector', {
    attrs: {
      "id": "event-topic-select",
      "options": _vm.topicOptions,
      "label": _vm.$t('event-flow.popup.form.topic'),
      "loading": _vm.topicsLoading,
      "empty-option-text": _vm.$t('event-flow.popup.form.topic-choose'),
      "has-empty-option": ""
    },
    model: {
      value: _vm.formData.topic,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "topic", $$v);
      },
      expression: "formData.topic"
    }
  }), _c('form-selector', {
    attrs: {
      "id": "event-responsible-select",
      "options": _vm.responsibleOptions,
      "label": _vm.$t('event-flow.popup.form.responsible'),
      "loading": _vm.responsiblesLoading,
      "empty-option-text": _vm.$t('event-flow.popup.form.responsible-choose'),
      "has-empty-option": ""
    },
    model: {
      value: _vm.formData.responsible,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "responsible", $$v);
      },
      expression: "formData.responsible"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_vm.eventItem.id ? _c('b-button', {
    staticClass: "w-100 mt-3",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.show('delete-modal');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('delete')) + " ")]) : _vm._e(), _c('confirmation-modal', {
    attrs: {
      "id": "delete-modal",
      "variant": "danger",
      "yes-key": "delete"
    },
    on: {
      "on-click-yes": _vm.onDelete
    },
    scopedSlots: _vm._u([{
      key: "body-text",
      fn: function () {
        return [_c('img', {
          staticClass: "modal-icon",
          attrs: {
            "src": require("@/assets/modal/danger.svg")
          }
        }), _c('h2', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.modal.delete-item.title')) + " ")]), _c('p', {
          staticClass: "modal-p"
        }, [_vm._v(" " + _vm._s(_vm.$t('event-flow.modal.delete-item.body')) + " ")])];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "w-100 mt-3",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`event-flow.popup.form.button.${_vm.eventItem.id ? 'update' : 'submit'}`)) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }